import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";
import { getUnitCode } from "../../utils";

export const form132 = (record: any) => {
  const [depCode] = StringHelper.verticalBarSplit(record.eDepartment);

  return {
    departmentCode: depCode,
    aflType: AFLType.ApplicationForLeave,
    layout: [
      {
        type: "header",
        value: {
          form: 3,
          department: StringHelper.verticalBarSplit(record.eUnit)[1],
          requestId: record.id,
          unitCode: getUnitCode(record),
        },
      },
      {
        type: "title",
        value: {
          sub: ["(Dành cho Đội phó, chuyên viên – nhân viên)"],
        },
      },
      {
        type: "salutation",
        value: ["Thủ trưởng CQ/ĐV"],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit(record?.eTitle)[1],
          },
          {
            type: "eWorkPlace",
            value: `${StringHelper.verticalBarSplit(record?.eTeam)[1]} - ${
              StringHelper.verticalBarSplit(record?.eDepartment)[1]
            }`,
          },
          {
            type: "",
            value: `Nay tôi làm đơn này kính đề nghị Thủ trưởng CQ/ĐV đồng ý giải quyết cho tôi được nghỉ phép năm ${new Date().getFullYear()}. lần thứ ${
              record?.ePaidLeaveTimes || ""
            }.`,
          },
          {
            type: "",
            value: `Số lượng phép theo tiêu chuẩn: ${record?.ePaidLeaveRemain} ngày (trong TH nghỉ phép từ lần thứ 2 trở đi, chỉ ghi rõ số ngày phép còn lại chưa thực hiện).`,
          },

          {
            type: "eVacationPeriods",
            value: record?.eVacationPeriods,
            docxType: "paragraph",
          },
          { type: "eLeavePlace", value: record?.eLeavePlace },
          { type: "ePhoneNumber", value: record?.ePhone },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value: `Rất mong nhận được sự chấp thuận của Thủ trưởng CQ/ĐV.`,
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", `- Lưu ${getUnitCode(record)}.`],
          },
          {
            type: "signature1",
            value: ["ĐỘI TRƯỞNG", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: [
              "PHÊ DUYỆT CỦA THỦ TRƯỞNG CQ/ĐV",
              record?.eSteps[2][0].name,
            ],
          },
        ],
        textBreak: 3,
      },
    ],
  };
};
